const formatString = str => {
  str = str.toString();
  return str.length === 1 ? "0" + str : str;
};

const dateToday = () => {
  let x = new Date();
  const newDate =
    x.getFullYear() +
    "-" +
    formatString(+x.getMonth() + 1) +
    "-" +
    formatString(x.getDate()) +
    "T" +
    formatString(x.getHours()) +
    ":" +
    formatString(x.getMinutes()) +
    ":00Z";
  return newDate;
};

const dateUTC = date => {
  let x = new Date(date);
  const newDate =
    x.getFullYear() +
    "-" +
    formatString(+x.getMonth() + 1) +
    "-" +
    formatString(x.getDate()) +
    "T" +
    formatString(x.getHours()) +
    ":" +
    formatString(x.getMinutes()) +
    ":00Z";
  return newDate;
};

const dateUTCComplete = date => {
  let x = new Date(date);
  const newDate =
    x.getFullYear() +
    "-" +
    formatString(+x.getMonth() + 1) +
    "-" +
    formatString(x.getDate()) +
    "T" +
    formatString(x.getHours()) +
    ":" +
    formatString(x.getMinutes()) +
    ":" +
    formatString(x.getSeconds()) +
    "Z";
  return newDate;
};

export { dateToday, dateUTC, dateUTCComplete };
